export const formSchema = {
	type: "object",
	required: [
		"title",
		"first_name",
		"last_name",
		"job_title",
		"mobile",
		"email",
		"repeat_email"
	],
	properties: {
		Enabled: {
			type: 'boolean',
			title: 'Disable this User'
		},
		title: {
			type: "string",
			title: "Title",
			enum: ["Mr", "Mrs", "Miss", "Mister", "Other"]
		},
		first_name: {
			type: "string",
			title: "First Name",
			maxLength: 100
		},
		last_name: {
			type: "string",
			title: "Last Name",
			maxLength: 100
		},
		job_title: {
			type: "string",
			title: "Job Title",
			maxLength: 50
		},
		mobile: {
			type: "string",
			title: "Mobile",
			maxLength: 15
		},
		email: {
			type: "string",
			title: "Email",
			maxLength: 100
		},
		repeat_email: {
			type: "string",
			title: "Confirm Email",
			maxLength: 100
		},
		roles: {
			type: "array",
			title: "Permissions",
			uniqueItems: true,
			items: {
				anyOf: [
					{
						enum: ['1'],
						title: 'One'
					}
				]
			}
		}
	}
};

export const uiSchema = {
	title: {
		"ui:autofocus": true,
	},
	mobile: {
		"ui:validations": {
			pattern: {
				value: "[0-9]{10}",
				message: "Please enter valid phone number.",
				inline: true
			}
		}
	},
	email: {
		"ui:validations": {
			pattern: {
				value: "[a-zA-Z]{1}[a-zA-Z\\-\\+_]@[a-zA-Z\\-_]+\\.com",
				message: "Please enter valid email",
				inline: true
			}
		}
	}
};
